export const defaultTitle: string =
  "Set Learning Free: Let kids' curiosity run wild with classes and groups on any topic you can imagine.";
